// extracted by mini-css-extract-plugin
export default {"pageLayout":"QMvPnUrSlBZIJX6YKkid__pageLayout___"};